// extracted by mini-css-extract-plugin
export default {"root":"OGxUWl","position-fixed":"UOVk9r","positionFixed":"UOVk9r","lightbox-layer":"zaJxo_","lightboxLayer":"zaJxo_"};